// extracted by mini-css-extract-plugin
export default {"food":"FoodItem_food__p0iG9","description":"FoodItem_description__uaNze","price":"FoodItem_price__TZdwU","qtyButton":"FoodItem_qtyButton__zjG7H"};